export enum AccessType {
  OWNER = "owner",
  ADMIN = "admin",
  ATTENDEE = "attendee",
}

export interface Users {
  user_id: number; // integer, Unique identifier for each user
  uuid: string; // stable UUID for external references (profile picture storage, etc.)
  created_at: number; // milli since epoch; The date and time the user account was created (e.g., 2024-01-02 14:30:00)
  last_login: number; // milli since epoch; The date and time the user last logged in (e.g., 2024-01-02 15:45:00)

  first_name: string; // User's first name (e.g., John)
  last_name: string; // User's last name (e.g., Doe)
  full_name: string; // User's full name (e.g., John Doe)
  email: string; // User's email address for login and communication (e.g., johndoe@example.com)
  title: string; // User's title or role (e.g., Project Manager)
  company: string; // The company the user is associated with (e.g., Acme Corporation)
  types_of_events: string[]; // examples: offsite, dinners, happy hours, incentive trips, conferences, other (specify)
  number_of_events_organized: number; // integer
  annual_event_budget: number; // estimated in USD
  industry: string; // The industry the company is associated with (e.g., Technology)
  headquarters_city: string; // The headquarters city of the company (e.g., San Francisco)
  bio?: string; // User's bio (e.g., "Product engineer, ex-yc | building @ nowadays.")

  phone?: string; // User's phone number for contact (digits only, without dial code)
  country_dial_code_id?: number | null; // Reference to countries_dial_codes table
  profile_picture_url?: string; // the profile picture

  is_northstar_user?: boolean;
  viewed_tutorial?: boolean; // Whether the user has viewed the enterprise tutorial

  currency_preference?: string | null; // ISO 4217 code; null/undefined → USD fallback
} // Table for storing user account information

export interface AdminUsers {
  user_id: number;
  slack_user_id: string | null;
  first_name: string;
  last_name: string;
  profile_picture_url?: string;
}

export interface Org {
  org_id: number;
  org_name: string;
  created_at: string;
  industry?: string;
  hq_city?: string;
  hq_address?: string;
  updated_at?: string;
}
